import React, { useEffect } from 'react';

import ChangePassword from './ChangePassword';
import AccountSettings from './AccountSettings';
import BilingAddress from './BilingAddress';
import ShippingAddress from './ShippingAddress';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomerProfileThunk } from '../../../../Website/redux/customerSlice';
import Myprofile from '../../Pages/myprofile/Myprofile';
import styles from './profilebody.module.css';

const ProfileBody = () => {
    const { customer, refresh, loading } = useSelector((state) => state.customer)


    console.log(customer);


    if (loading) {
        return <div>please wait...</div>
    }

    return (
        <Myprofile>
            <div className={styles.profileStack}>

                <AccountSettings customer={customer} />

                <ChangePassword />

                <div className={styles.addressColumns}>
                    <BilingAddress />
                    <ShippingAddress />
                </div>

            </div >
        </Myprofile>
    );
};

export default ProfileBody;
